import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="left-nav"
export default class extends Controller {
  closeOrOpen() {
    if (window.innerWidth < 1100) {
      // Mobile menu is open by default
      this.close();
    } else if (window.innerWidth > 1200) {
      this.open();
    }
  }
  
  connect() {
    if (window.innerWidth < 768) {
      // Mobile menu is open by default
      this.close();
    }
  }

  close() {
    this.element.classList.remove('open');
  }

  open() {
    this.element.classList.add('open');
  }
}
